import { TextField } from "@mui/material/index"
import { TimePicker } from "@mui/x-date-pickers"
import { useEffect, useState } from "react";

interface ICurrentTimeframe {
    p: any,
    disabled: boolean,
    handleChangeForm: (newValue: any | null, secondValue: any) => void
}

const CurrentTimeFrame = ({p, disabled, handleChangeForm}: ICurrentTimeframe) => {
    const {isOpen} = p?.data;
    const [value, setValue] = useState(p.value);
    useEffect(() =>{
        if(!isOpen) {
            setValue(null);
            handleChangeForm(null, p);
        }

    }, [isOpen]);

    useEffect(() => {
        if(!!p.value){
            setValue(p.value)
        }
    }, [p.value])

    const changeHandler = (e: any) => {
        handleChangeForm(e, p)
    }

    return (
        <TimePicker
            disabled={disabled || !isOpen}
            onChange={(e) => changeHandler(e)}
            renderInput={(params) => <TextField {...params} />}
            value={value}
        />
    );
}
export default CurrentTimeFrame;